const cantons = (state) => state.cantons;

export default {
    cantons,
};
